import request from 'config/apiConfig';

export const fetchToken = (payload: { dashboardId: string }) => {
  return request.get(`analytics/dashboard/${payload.dashboardId}`, {});
};

export const fetchRole = (payload: { token: string; baseUrl: string }) => {
  return request.get(`${payload.baseUrl}api/v1/me/roles/`, { headers: { 'X-Guesttoken': payload.token } });
};

export const fetchDashboard = (payload: { token: string; baseUrl: string }) => {
  return request.get(`${payload.baseUrl}api/v1/dashboard/`, { headers: { 'X-Guesttoken': payload.token } });
};

export const fetchChart = (payload: { token: string; baseUrl: string; dashboardId: string }) => {
  return request.get(`${payload.baseUrl}api/v1/dashboard/${payload.dashboardId}/charts`, {
    headers: { 'X-Guesttoken': payload.token }
  });
};

export const fetchDatasets = (payload: { token: string; baseUrl: string; dashboardId: string }) => {
  return request.get(`${payload.baseUrl}api/v1/dashboard/${payload.dashboardId}/datasets`, {
    headers: { 'X-Guesttoken': payload.token }
  });
};

export const fetchBusinessGroup = () => {
  return request.get(`settings/api/v1/management/marketer/config/onboarding/tag/business-group/choices/`);
};

export const fetchEngagementWidgetData = (key: string, startTime: string, endTime: string, videoIds: string) => {
  return request.get(`analytics/${key}`, {
    params: {
      type: 'normalized',
      startTime: startTime,
      endTime: endTime,
      contentId: videoIds
    }
  });
};

// export const fetchEngagementOverTimeData = (startTime: string, endTime: string) => {
//   return request.get(
//     `analytics/engagements-over-time?type=normalized&startTime=${startTime}&endTime=${endTime}`
//   );
// };
